<template>
  <div>
    <div class="title">
      <span class="font16">{{title}}</span>
      <el-tooltip class="item" effect="dark" :content="tooltip" v-if="tooltip" placement="top">
        <i class="el-icon-question tooltip-icon"></i>
      </el-tooltip>
    </div>
    <div class="title-right">
      <slot>
        <a :href="link" v-if="link" class="blue">更多>></a>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'dufaultTitle',
  props: [
    'title',
    'tooltip',
    'link'
  ],
  data () {
    return {

    }
  },
  methods: {},
  created () {
  }
}
</script>
<style scoped>
/* .title {
  color: blue;
} */
.title {
  float: left;
}
.title-right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/common/default/Title.vue